import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import type { OutstandingSecondaryConsentItem } from '../hooks/useOutstandingSecondaryConsents'

type OutstandingSecondaryConsentsCardProps = {
  items: OutstandingSecondaryConsentItem[]
}

const OutstandingSecondaryConsentsCard: React.FC<OutstandingSecondaryConsentsCardProps> = ({ items }) => {
  if (items.length === 0) return null

  return (
    <section className="flex flex-col rounded-xl border border-[#E5E7EB] bg-white p-6 shadow-lg shadow-gray-900/10">
      <h2 className="text-2xl leading-9 font-semibold tracking-tight text-[#002C22]">
        <FormattedMessage id="home.secondaryConsents.heading" defaultMessage="Outstanding secondary consents" />
      </h2>
      <p className="text-text-body mt-3 text-sm leading-6">
        <FormattedMessage
          id="home.secondaryConsents.body"
          defaultMessage="These optional choices still need your attention. You can review and answer them whenever you're ready."
        />
      </p>
      <ul className="mt-6 list-disc space-y-3 pl-5 text-base leading-6 text-gray-900">
        {items.map((item) => (
          <li key={item.id}>{item.title}</li>
        ))}
      </ul>
      <div className="mt-6 flex justify-end">
        <Link
          to="/consents/manage"
          className="inline-flex items-center justify-center rounded-full bg-[#006045] px-5 py-3 text-sm font-semibold text-white shadow-xs transition hover:bg-[#004d37] focus:ring-2 focus:ring-[#006045]/20 focus:outline-none"
        >
          <FormattedMessage id="home.secondaryConsents.reviewButton" defaultMessage="Review secondary consents" />
        </Link>
      </div>
    </section>
  )
}

export default OutstandingSecondaryConsentsCard
